// === Custom Reveal Animations for Shopify ===
function initRevealAnimations(context = document) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('reveal-visible');
        revealObserver.unobserve(entry.target); // animar solo una vez
      }
    });
  }, { threshold: 0.15 });

  const elements = context.querySelectorAll('.reveal, .reveal-right, .reveal-left, .reveal-top');


  elements.forEach(el => {
    // Forzar animación inmediata si el elemento ya está visible
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('reveal-visible');
    }
    // Luego observar normalmente para scroll
    revealObserver.observe(el);
  });
}

// Ejecutar al cargar la página
document.addEventListener('DOMContentLoaded', () => {
  initRevealAnimations();
});

// Ejecutar cuando Shopify renderiza secciones dinámicas
document.addEventListener('shopify:section:load', (event) => {
  initRevealAnimations(event.target);
});


function loadContent() {
  const path = window.location.pathname.toLowerCase();
  const container = document.getElementById('faq-content');
  const title = document.getElementById('title');

  if (path.includes('/ca')) {
    container.innerHTML = contentCA;
    title.textContent = 'Qui som';
  } else {
    container.innerHTML = contentES;
    title.textContent = 'Quiénes somos';
  }

  // ⚡️ Muy importante: esperar a que el DOM renderice los <details>
  setTimeout(() => {
    initRevealAnimations(container);
  }, 50); // 50ms basta para que se procesen los elementos
}
// Ejecutar al cargar la página
window.addEventListener('DOMContentLoaded', loadContent);

// Ejecutar cuando Shopify carga secciones dinámicas
document.addEventListener('shopify:section:load', (event) => {
  loadContent();
});

// === Desplegar descripción producto ===

document.addEventListener("DOMContentLoaded", function(){

  const desc = document.getElementById("productDescription");
  const btn = document.getElementById("toggleDescription");

  if(!desc || !btn) return;

  btn.addEventListener("click", function(){

    desc.classList.toggle("expanded");

    if(desc.classList.contains("expanded")){
      btn.textContent = "Mostrar menos";
    } else {
      btn.textContent = "Desplegar más";
    }

  });

});